import React from 'react';
import { paymentAccountType, paymentOTPType } from '../../../FreedomConstants/freedomConstants';
import FreedomAlert from '../../../Components/SharedComponent/FreedomAlert/FreedomAlert';
import { Grid } from '@mui/material';
import FreedomWrapperRoot from '../../../Components/SharedComponent/FreedomWrapperRoot/FreedomWrapperRoot';
import FreedomOTP from '../../../Components/FreedomOTP';
import BankDetail from './components/BankDetail';
import { PaymentElement } from '@stripe/react-stripe-js';
import FreedomPanel from '../../../Components/SharedComponent/FreedomPanel/FreedomPanel';
import { UpgradeProfileStepWrapper } from '../UpgradeProfile1';

const UpgradeProfileThirdStep = ({ paymentPayMethod, openAlertMessage, opentAlert, setOpenAlert, showSnackbar, setActiveStep, systemID, confirmOTP, openDialog, setOpenDialog, setLoading }) => {
  if (paymentPayMethod == paymentAccountType.creditCardAccount) {
    return (
      <Grid container item sm={12} lg={12}>
        <UpgradeProfileStepWrapper>
          <Grid container item justifyContent={'center'}>
            <Grid item xs={12} md={8} xlll={6} m={1}>
              <FreedomAlert severity={'error'} message={openAlertMessage} opentAlert={opentAlert} setOpenAlert={setOpenAlert} />
              <PaymentElement />
            </Grid>
          </Grid>
        </UpgradeProfileStepWrapper>
      </Grid>
    );
  } else if (paymentPayMethod == paymentAccountType.internalAccount) {
    return (
      <Grid item sm={12} lg={12}>
        <UpgradeProfileStepWrapper>
          <Grid container justifyContent="center">
            <FreedomOTP showMessage={showSnackbar} setActiveStep={setActiveStep} systemID={systemID} paymentOTPType={paymentOTPType.account} ref={confirmOTP} setLoading={setLoading} />
          </Grid>
        </UpgradeProfileStepWrapper>
      </Grid>
    );
  } else if (paymentPayMethod == paymentAccountType.bankAccount) {
    return (
      <Grid item sm={12} lg={12}>
        <UpgradeProfileStepWrapper>
          <BankDetail openDialog={openDialog} setOpenDialog={setOpenDialog} systemID={systemID} />
        </UpgradeProfileStepWrapper>
      </Grid>
    );
  }
};

export default UpgradeProfileThirdStep;
